import { InputGroup, } from "@smartsuite/react-ui/lib/components/forms/InputGroup/InputGroup";
import React from "react";
import cx from "classnames";
export const EditorInputGroup = ({ children, className, heightMode = "grow", ...rest }) => {
    return (React.createElement(InputGroup, { inputBackground: "white-new", className: cx("editor-input-group", `editor-input-group--height-mode-${heightMode}`, className), ...rest }, children));
};
